import {USER_ROLES, WEBBACK_V2_API} from "@constants";
import {useUserApp} from "@hooks";

const V2_PRICING = `${WEBBACK_V2_API}/pricing`

// **This is the one table of the screen whose url still depends on the role, and that is on
// purpose.** It asks for `market-comparison`, and v2 kept v1's split only where it is real:
//
// - every other endpoint of Pricing Overview is **one route for both roles** (see the parent hook);
// - **this table keeps its own endpoint**, because the retailer variant answers ~15 different keys
//   (`myActualPrice`, `myListPrice`, `myStock`, `stockCompetition`, `minSite`…). Unify where the
//   contract is the same, separate where there are two — §6.3 of
//   dipi-webback-v2/plans/869e5pfw2--data-market-analyzer.md.
//
// It is the same endpoint Market Analyzer's table uses, so this hook mirrors `urlApiTable` there.
// Both variants are regressed against their own half of v1.
//
// The MARKETPLACES branch is dropped rather than ported: out of scope, and it pointed at the same
// url as STANDARD.

export default function usePricingDiscountTopMarketDispersionsRoleConfig() {
	const { userRole } = useUserApp()
	const isRetailerUser = userRole === USER_ROLES.RETAILER

	return {
		userRole,
		urlApi: isRetailerUser
			? `${V2_PRICING}/pricing-retailers`
			: `${V2_PRICING}/pricing-and-discount`,
		isRetailerUser,
		isStandardUser: userRole === USER_ROLES.STANDARD
	}
}
